// extracted by mini-css-extract-plugin
module.exports = {"Footer":"ChartFooter_Footer__29ZtN","content-box":"ChartFooter_content-box__1bFba","footer-content":"ChartFooter_footer-content__3L0z3"};